import CircularProgress from '@mui/material/CircularProgress'
import { connectorAPI } from 'actions/connector.js'
import clsx from 'clsx'
// components
import { AuthTemplate } from 'components/templates/authTemplate/index.tsx'
import { CONSTS } from 'config/objectConst.js'
import { workspaceApi } from 'features/workspace'
import { useState } from 'react'
import { useEffect } from 'react'
import Select from 'react-select'
import { useAppSelector } from 'shared/hooks/store.ts'
import { typo } from 'shared/styles'
import { Button } from 'shared/ui'

import { appSelectors } from '../../../../redux/reducers/app.ts'
import css from './NoTimezone.module.scss'

type Option = (typeof CONSTS.TIME_ZONES)[0]

// TODO: make one select component

const cn = AuthTemplate.cn

export function NoTimezone() {
	const [zone, setZone] = useState(getInitial)

	const refreshAccessToken = useAppSelector(appSelectors.refreshAccessToken)
	const [send, { isLoading, isSuccess }] =
		workspaceApi.useTimezoneOffsetMutation()

	// biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
	useEffect(() => {
		if (isSuccess) {
			Promise.all([refreshAccessToken(), connectorAPI.getSnailyProfile()])
		}
	}, [isSuccess])

	const saveTimeZone = () => {
		if (!isLoading) {
			send(Number(zone.value))
		}
	}

	return (
		<AuthTemplate active={4}>
			<h1 className={cn.title}> Choose your GMT and working hours</h1>

			<p className={cn.text}>
				You can reset this step in personal account later
			</p>

			<Select
				className={clsx('simple-select', css.select)}
				classNamePrefix='select'
				onChange={newValue => newValue && setZone(newValue)}
				options={CONSTS.TIME_ZONES}
				styles={{
					option: (styles, { isSelected }) => ({
						...styles,

						'&:active': {
							backgroundColor: 'hsl(from var(--primary) h s l / 50%)'
						},
						'&:hover': {
							backgroundColor: 'hsl(from var(--primary) h s l / 50%)'
						},
						backgroundColor: isSelected ? 'var(--primary)' : 'transparent',
						color: 'var(--black)',
						cursor: 'pointer'
					})
				}}
				value={zone}
			/>

			<Button
				className={clsx(css.action, cn.action)}
				onClick={saveTimeZone}
				type='button'
				typography={typo.largeButton}
			>
				{isLoading ? (
					<CircularProgress
						classes={{ colorPrimary: 'material-loader-black' }}
						size={20}
					/>
				) : (
					'Next'
				)}
			</Button>
		</AuthTemplate>
	)
}

function getInitial(): Option {
	const key = String(new Date().getTimezoneOffset() * -1)

	return (
		CONSTS.TIME_ZONES.find(item => item.value === key) ?? CONSTS.TIME_ZONES[0]
	)
}
